import Component from 'flarum/Component';
import icon from 'flarum/helpers/icon';

/* global m */

/**
 * Identical to the core Select but with the ability to mark disabled
 */
export default class SelectWithDisabled extends Component {
    view() {
        const {options, onchange, value, disabled} = this.props;

        return m('span.Select', [
            m('select.Select-input FormControl', {
                onchange: onchange ? m.withAttr('value', onchange.bind(this)) : undefined,
                value,
                disabled,
            }, Object.keys(options).map(key => m('option', {
                value: key,
            }, options[key]))),
            icon('fas fa-sort', {className: 'Select-caret'})
        ]);
    }
}
